<div class="track-number-container" [class.small]="small">
    {{ trackingServiceIdentifierToName(track.service) }}:
    <span class="track-number" title="трек-номер Mover`а" (click)="onClickTrackNumber(track.internal_track_number)">{{ track.internal_track_number }}</span>
    <span *ngIf="track.external_track_number">
                      <span class="glyphicon glyphicon-link"></span>
                      <span class="track-number" title="трек-номер '{{ trackingServiceIdentifierToName(track.service) }}'" (click)="onClickTrackNumber(track.external_track_number)">{{ track.external_track_number }}</span>
                    </span>
</div>
